import { createSlice } from "@reduxjs/toolkit";

const bookingsSlice = createSlice({
  name: "bookingsSlice",
  initialState: {
    items: [],
    isLoading: false,
    meta: {
      total: 0,
      pageSize: 10,
      currentPage: 1,
    },
  },
  reducers: {
    populateData(state, action) {
      state.items = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setMeta: (state, action) => {
      state.meta = action.payload;
    },
  },
});

export const sliceActions = bookingsSlice.actions;

export default bookingsSlice.reducer;
